import React from 'react';
import styled from 'styled-components';
import { Flex, Text, TextHeadingOne, TextInline } from '@cko/primitives';
import { IconActionAlert } from '@cko/icons';
import { useLocation } from 'react-router-dom';
import { ErrorImage } from '../../assets';
import { PageHeader } from '../PageHeader';
import { trackEvent } from '../../utils';
const Image = styled.div `
  height: 208px;
  margin-top: var(--layout-shoe);
  width: 208px;
`;
const Wrapper = styled(Flex) `
  flex-direction: column;
  min-height: calc(100vh - var(--layout-saxophone));
`;
const Header = styled(Flex) `
  align-items: center;
  height: 80px;

  & span {
    font: var(--heading-md);
  }

  & svg {
    fill: var(--base-icon-bad);
    margin: var(--layout-sandgrain) var(--layout-soybean) var(--layout-sandgrain) var(--layout-seed);
  }
`;
const Body = styled(Flex) `
  align-items: center;
  flex-direction: column;
  flex-grow: 1;
  justify-content: center;
  min-height: 100%;
`;
const Issue = styled(Text) `
  font: var(--heading-md);
  margin: var(--layout-shoe) var(--layout-sandgrain) var(--layout-sandgrain);
  text-align: center;
`;
const Contact = styled(Text) `
  margin: var(--layout-shoe);

  a {
    color: var(--action-text-hover);
    text-decoration: none;
  }
  a:hover {
    text-decoration: underline;
  }
`;
const issues = {
    defaultIssue: 'There is an issue with your personal account',
    authSdkError: 'There has been an issue signing you in, please try again or contact our support.',
    jwtExpiredOrInTheFuture: 'There is a mismatch between your system timezone and time settings. Please update your settings to set the time automatically based on your location.',
};
const getIssueString = (locationPathName, error) => {
    if (error &&
        'errorSummary' in error &&
        (error.errorSummary === 'The JWT expired before it was issued' ||
            error.errorSummary === 'The JWT was issued in the future')) {
        return issues.jwtExpiredOrInTheFuture;
    }
    // We've only seen the below circumstance occur when the user has manually set their system clock,
    // and this is different to the timezone they are in - however, if you're seeing this there may be another cause.
    if (error && error.name === 'AuthSdkError' && locationPathName.includes('/implicit/callback')) {
        trackEvent('login.timezone.error', { error: JSON.stringify(error) });
        return issues.authSdkError;
    }
    if (error && error.name === 'OAuthError' && 'error_description' in error) {
        return error.error_description;
    }
    return issues.defaultIssue;
};
export const Error = ({ error }) => {
    const location = useLocation();
    const issue = getIssueString(location.pathname, error);
    return (React.createElement(Wrapper, { id: "error-id" },
        React.createElement(PageHeader, { justifyContent: "space-between" },
            React.createElement(TextHeadingOne, { m: "var(--layout-sandgrain)" }, "Home")),
        React.createElement(Flex, { p: 0, flexDirection: "column", flexGrow: 1 },
            React.createElement(Header, { py: "var(--layout-sandgrain)" },
                React.createElement(TextInline, null,
                    React.createElement(IconActionAlert, { "data-testid": "alert-icon" }),
                    "Something went wrong")),
            React.createElement(Body, null,
                React.createElement(Image, { "data-testid": "account-error-image" },
                    React.createElement(ErrorImage, null)),
                React.createElement(Issue, null, issue),
                React.createElement(Contact, null,
                    "Please contact ",
                    React.createElement("a", { href: "mailto:support@checkout.com" }, "support@checkout.com"))))));
};
